import {splitPermissions} from './utils';
import {
  createFetchActionForNamespace,
  createPostActionForNamespace,
  createReducer,
  createFetchReducers,
  createFetchSelectors,
  noDataForAction
} from 'utils/reducers';
import {transformFiltersForStoreToFiltersForApi} from 'utils/filters';
import {selectFilters, FILTERS} from 'ducks/filters';

const createFetchAction = createFetchActionForNamespace('teams/list');
const createPostAction = createPostActionForNamespace('teams/list');

export const fetchMyTeams = createFetchAction({
  name: 'FETCH_MY_TEAMS',
  initialAction: noDataForAction,
  stateKey: 'myTeams',
  defaultStateValue: []
});
const myTeamSelector = createFetchSelectors(fetchMyTeams);
export const selectMyTeams = myTeamSelector.data;
export const selectMyTeamsLoading = myTeamSelector.isLoading;

export const fetchAllTeams = createFetchAction({
  name: 'FETCH_ALL_TEAMS',
  initialAction: noDataForAction,
  stateKey: 'allTeams',
  defaultStateValue: [],
  extraGetParamsSelectors: [
    state =>
      transformFiltersForStoreToFiltersForApi(
        selectFilters(state, FILTERS.MY_TEAMS_TEAMS)
      )
  ]
});
const allTeamSelector = createFetchSelectors(fetchAllTeams);
export const selectAllTeams = allTeamSelector.data;
export const selectAllTeamsLoading = allTeamSelector.isLoading;

export const fetchStaffMembers = createFetchAction({
  name: 'FETCH_STAFF_MEMBERS',
  initialAction: noDataForAction,
  stateKey: 'staffMembers',
  defaultStateValue: [],
  extraGetParamsSelectors: [
    state =>
      transformFiltersForStoreToFiltersForApi(
        selectFilters(state, FILTERS.MY_TEAMS_MEMBERS)
      )
  ]
});
const staffMembersSelector = createFetchSelectors(fetchStaffMembers);
export const selectStaffMembers = staffMembersSelector.data;
export const selectStaffMembersLoading = staffMembersSelector.isLoading;

export const fetchPermissionEntities = createFetchAction({
  name: 'FETCH_PERMISSION_ENTITIES',
  initialAction: noDataForAction,
  stateKey: 'permissionEntities'
});
export const selectPermissionEntities = createFetchSelectors(
  fetchPermissionEntities
).data;

export const selectPermissionNamespacedEntities = state => {
  return state.teams.list.permissionEntities;
};

export const createTeam = createPostAction({
  name: 'CREATE_TEAM',
  initialAction: (
    {name, avatar, permissionEntities, locations},
    extraActions = []
  ) => ({
    payload: {
      name,
      avatar,
      permissionEntities,
      locations,
      extraActions
    }
  })
});

export const inviteNewStaffMember = createPostAction({
  name: 'INVITE_NEW_STAFF_MEMBER',
  initialAction: ({name, email, jobTitle, teams}, extraActions = []) => ({
    payload: {
      name,
      email,
      jobTitle,
      teams,
      extraActions
    }
  }),
  formName: 'inviteNewStaffMember'
});

const fetchPermissionEntitiesReducer = () =>
  createFetchReducers(fetchPermissionEntities, (state, action) => {
    const [locationSpecific, generic] = splitPermissions(action.payload);

    return {
      ...state,
      permissionEntities: {
        data: action.payload,
        locationSpecific,
        generic
      }
    };
  });

const initialState = {
  permissionEntities: {data: {}, locationSpecific: [], generic: []}
};

const fetchReducers = createReducer(initialState, {
  ...createFetchReducers(fetchMyTeams),
  ...createFetchReducers(fetchAllTeams),
  ...createFetchReducers(fetchStaffMembers),
  ...fetchPermissionEntitiesReducer()
});

const reducer = (state = initialState, action) => {
  const newState = fetchReducers(state, action);

  switch (action.type) {
    default:
      return newState;
  }
};

export default reducer;

export {default as teamsListSaga} from './saga';
